import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { resolveColorProperty } from '@gn-audio/jss-components';

import GenericBentoGridItem from 'composables/Product/GenericBentoGrid/GenericBentoGridItem';
import { GenericBentoGridProps } from 'composables/Product/GenericBentoGrid/GenericBentoGridTypes';
import { useSpotTracking } from 'utils/hooks/useSpotTracking';

const GenericBentoGrid = ({ fields }: GenericBentoGridProps) => {
  const { backgroundColor, genericBentoGridItems, trackingSpotName } = fields;
  const spotRef = useSpotTracking(trackingSpotName?.value);
  const resolvedBackgroundColor = resolveColorProperty(backgroundColor?.value);
  const isTileSmall = (index: number) => (index - 1) % 4 === 0 || (index - 2) % 4 === 0;
  const isLastItem = (index: number) => index === genericBentoGridItems.length - 1;
  const isOddLength = genericBentoGridItems.length % 2 !== 0;
  const getColClasses = (index: number) => ({
    'md:col-span-2': isTileSmall(index) && !(isOddLength && isLastItem(index)),
    'md:col-span-3': !isTileSmall(index) && !(isOddLength && isLastItem(index)),
    'md:col-span-5': isOddLength && isLastItem(index),
  });

  return (
    <div
      ref={spotRef}
      data-wt-spot={trackingSpotName?.value}
      style={{ backgroundColor: resolvedBackgroundColor }}
    >
      <div className="container flex items-center justify-center">
        <div className="grid w-full auto-rows-fr gap-6 text-center md:grid-cols-5">
          {genericBentoGridItems.map((item, index) => (
            <div className={classNames('grid-item', getColClasses(index))} key={item.id}>
              <GenericBentoGridItem
                backgroundColor={item.backgroundColor}
                genericBentoGridItemContent={item.genericBentoGridItemContent}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default withDatasourceCheck()(GenericBentoGrid);
